// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-popup[data-v-2f204347]  .modal{padding:60px 29px 21px 29px}.modal-popup[data-v-2f204347]  .modal .action{display:flex;justify-content:space-around}.modal-popup[data-v-2f204347]  .modal .action button{width:120px}h1[data-v-2f204347]{text-align:center;font-family:\"Instrument Serif\",Georgia,Times New Roman,serif;font-style:normal;font-weight:400;font-size:28px;line-height:38px}", ""]);
// Exports
module.exports = exports;
